import React, { createContext, useContext, useReducer, useEffect } from 'react';
import { matrimonyApi } from './matrimonyApi';

const AuthContext = createContext(null);

const CACHE_KEY = 'mtm_auth';
const GUEST = { user: null, profile: {}, isAdmin: false, adminName: '', adminViaSmabizz: false };

function readCache() {
  try { return JSON.parse(localStorage.getItem(CACHE_KEY)) || null; } catch { return null; }
}
function writeCache(s) {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify(s)); } catch {}
}
function clearCache() {
  try { localStorage.removeItem(CACHE_KEY); } catch {}
}

function authReducer(state, action) {
  switch (action.type) {
    case 'SET':   return action.payload;
    case 'CLEAR': return GUEST;
    case 'SET_PROFILE': return { ...state, profile: action.profile };
    default: return state;
  }
}

export function AuthProvider({ children }) {
  const cached = readCache();
  const [auth, dispatch] = useReducer(authReducer, cached || GUEST);

  function applyData(data) {
    const next = {
      user:            data.user && data.user.id ? data.user : null,
      profile:         data.profile || {},
      isAdmin:         !!data.admin,
      adminName:       data.adminName || (data.user && data.user.name) || '',
      adminViaSmabizz: !!data.adminViaSmabizz,
    };
    dispatch({ type: 'SET', payload: next });
    writeCache(next);
  }

  useEffect(() => {
    matrimonyApi.getMe().then(applyData).catch(() => {
      dispatch({ type: 'CLEAR' });
      clearCache();
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const refresh = () =>
    matrimonyApi.getMe().then(applyData).catch(() => { dispatch({ type: 'CLEAR' }); clearCache(); });

  const logout = async () => {
    await matrimonyApi.logout().catch(() => {});
    dispatch({ type: 'CLEAR' });
    clearCache();
  };

  const setProfile = (profile) => dispatch({ type: 'SET_PROFILE', profile });

  return (
    <AuthContext.Provider value={{ ...auth, refresh, logout, setProfile }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
